module.exports = __webpack_public_path__ + "assets/img/karl.78fcbbb3.jpg";